module.exports = __webpack_public_path__ + "img/logo-icon.450cba14.png";